import SignIn from '../components/sign-in/SignIn';

export default function SignInPage({ setIsAuthenticated, setSessionExpiredMessage, setUserProfile, setUserRole}) {
    return (
        <SignIn setIsAuthenticated={setIsAuthenticated} setSessionExpiredMessage={setSessionExpiredMessage} setUserProfile={setUserProfile}
        setUserRole={setUserRole}/>
    );
};